module.exports = __webpack_public_path__ + "assets/img/HistoryIcon.1a308dbf.svg";